import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppSidebarItem } from 'containers';
import { VerticalMenu } from 'components';
import { connect } from 'react-redux';
var AppSidebar = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    isPartner: state.config && state.config.userType && state.config.userType.isPartner
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AppSidebar, _Component);

  var _super = _createSuper(AppSidebar);

  function AppSidebar() {
    _classCallCheck(this, AppSidebar);

    return _super.apply(this, arguments);
  }

  _createClass(AppSidebar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          links = _this$props.links,
          theme = _this$props.theme,
          isPartner = _this$props.isPartner;
      var items = links.filter(function (item) {
        return isPartner || !item.partnerOnly;
      }).map(function (item, index) {
        return /*#__PURE__*/React.createElement(AppSidebarItem, {
          svgIcon: item.svgIcon,
          index: item.index,
          link: item.link,
          key: index,
          iconName: item.iconName,
          name: item.name,
          tooltip: item.tooltip,
          text: item.text,
          theme: theme
        });
      });
      return /*#__PURE__*/React.createElement(VerticalMenu, {
        width: '70px',
        bgColor: theme.colors.black3,
        style: this.props.verticalMenuStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "",
        style: {
          padding: 0
        }
      }, items));
    }
  }]);

  return AppSidebar;
}(Component), _defineProperty(_class2, "propTypes", {
  links: PropTypes.array.isRequired,
  isPartner: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired
}), _temp)) || _class);
export default AppSidebar;